import React, { useEffect } from "react";

export const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container">
      <div className="termsPage">
        <h2>GLOBAL LEGAL DISCLAIMER & TERMS OF USE/CONDITIONS</h2>
        <p className="mb-3">
          <b>Last Updated:</b> 20.03.2025{" "}
        </p>

        <div className="legalNotice">
          <p>You are paying solely to access our content.</p>
          <p>
            Your membership fee is solely for access to research and
            educational content. It is not an investment, trading deposit or
            capital entrusted to us.
          </p>
          <p>
            You are paying for access to watch my trades and trading
            activity. This does not constitute financial advice, and I am not
            responsible for any losses you may incur from following or
            replicating my trades. Trade at your own risk.
          </p>
        </div>

        <p className="mb-3">
          Welcome to <a href="https://waqarzaka.net/">www.waqarzaka.net</a> (the
          "Website"). By accessing or using this Website, you agree to the
          following disclaimers, terms, and policies. If you do not agree with
          any part of this disclosure, please discontinue use immediately.{" "}
        </p>

        <p className="mb-3">
          For <a href="https://waqarzaka.net/">www.waqarzaka.net</a> & All
          Associated Signal / Telegram / WhatsApp Groups
        </p>

        <h2>WAQAR ZAKA PREMIUM CRYPTO GROUP</h2>
        <p className="mb-3">
          By clicking "I AGREE &amp; JOIN", purchasing a subscription, or accessing the Waqar Zaka Premium Crypto
          Group, you confirm that you have read, understood and voluntarily accepted the Waqar Zaka Premium Crypto
          Group Subscriber Terms, Risk Disclosure, Waiver, Release, Limitation of Liability &amp; Indemnity Agreement
          ("Agreement").
        </p>
        <p className="mb-2">By accepting, you expressly acknowledge and agree that:</p>
        <ul className="mb-3">
          <li>Cryptocurrency trading and investment involve substantial risk, including the possibility of losing some or all of your invested capital.</li>
          <li>The Group may provide BUY/SELL, ENTRY/EXIT, STOP-LOSS, TAKE-PROFIT, market-analysis and other trading signals or opinions, but no signal or advice is a guarantee of profit or protection against loss.</li>
          <li>You make your own final trading and investment decisions and are solely responsible for determining whether, when and how you act upon any signal or information provided through the Group.</li>
          <li>Actual execution prices may differ from published entry or exit prices because of market movement, volatility, liquidity, spread, delay or slippage.</li>
          <li>Leverage, futures, margin and similar products can result in losses exceeding ordinary spot-market losses and may result in liquidation.</li>
          <li>The subscription fee is paid for access to the Group and its content/signals, and is not payment for any guaranteed profit, return or successful trading outcome.</li>
          <li>The Group Operator does not take custody or control of your cryptocurrency, exchange account, wallet, private keys or trading funds unless expressly agreed in a separate written arrangement.</li>
          <li>To the maximum extent permitted by applicable law, you release and agree to indemnify and hold harmless the Group Operator and its authorized representatives from claims, losses, damages, liabilities and expenses arising from your own trading/investment decisions or your use of the Group's information and signals.</li>
          <li>This waiver and indemnity does not exclude liability that cannot legally be excluded, including liability arising from fraud, wilful misconduct or other non-excludable liability.</li>
          <li>You will not treat any message, signal, chart, price target, entry, exit, stop-loss or other communication as a guarantee of a particular result.</li>
          <li>You have sufficient knowledge and understanding of cryptocurrency trading to make your own decisions, or you will obtain independent professional advice before trading.</li>
          <li>You are legally entitled and competent to enter into this Agreement.</li>
        </ul>

        <h3>1. Nature of the Group</h3>
        <p className="mb-2">1.1. The Waqar Zaka Premium Crypto Group is a paid subscription-based community through which the Subscriber may receive information, educational material, market commentary, research, opinions, analysis, technical observations, trading ideas, market updates, strategies, or other crypto-related content.</p>
        <p className="mb-2">1.2. Unless expressly stated otherwise in writing, the Group Operator does not take custody of the Subscriber's funds, cryptocurrency, exchange accounts, wallets, private keys or other assets.</p>
        <p className="mb-2">1.3. The Subscriber remains solely responsible for all trading, investment and financial decisions made by the Subscriber.</p>
        <p className="mb-3">1.4. Nothing contained in the Group shall be construed as a guarantee, assurance, promise or representation that any particular cryptocurrency, trade, strategy or market view will generate a profit or avoid a loss.</p>

        <h3>2. Acknowledgment of High Risk</h3>
        <p className="mb-2">2.1. The Subscriber expressly acknowledges that cryptocurrency and virtual-asset markets are highly volatile and speculative and may result in partial or complete loss of invested capital.</p>
        <p className="mb-2">2.2. The Subscriber understands that cryptocurrency prices may change rapidly because of, among other things, market volatility, liquidity conditions, leverage, exchange failures, hacking, cyberattacks, regulatory developments, technological failures, market manipulation, network congestion, token-specific events and other circumstances beyond the control of the Group Operator.</p>
        <p className="mb-2">2.3. The Subscriber acknowledges that past performance, previous calls, historical results, screenshots, examples, hypothetical trades or previous profits do not constitute a guarantee or indication of future results.</p>
        <p className="mb-3">2.4. The Subscriber agrees not to commit money which he/she cannot afford to lose.</p>

        <h3>3. No Guarantee of Profit</h3>
        <p className="mb-2">3.1. The Subscriber expressly acknowledges that the Group Operator makes no guarantee whatsoever regarding profit, return on investment, accuracy of any prediction, success of any trade or future performance of any cryptocurrency.</p>
        <p className="mb-2">3.2. Any statement concerning a potential price target, entry, exit, stop-loss, strategy, market direction or potential return represents an opinion or analysis at the relevant time and may prove to be incorrect.</p>
        <p className="mb-3">3.3. The Subscriber understands that even where information or analysis provided by the Group Operator is made honestly and in good faith, the market may move contrary to such analysis.</p>

        <h3>4. Subscriber's Independent Decision-Making</h3>
        <p className="mb-2">4.1. All decisions to buy, sell, hold, short, long, stake, leverage, transfer or otherwise deal in any virtual asset shall be made solely by the Subscriber.</p>
        <p className="mb-2">4.2. The Subscriber shall independently assess the suitability, legality, risks and financial consequences of every transaction.</p>
        <p className="mb-2">4.3. The Subscriber shall not treat any communication in the Group as an instruction that obliges the Subscriber to enter into a transaction.</p>
        <p className="mb-3">4.4. The Subscriber acknowledges that the Group Operator does not know the Subscriber's complete financial circumstances, investment objectives, risk tolerance, liabilities or personal circumstances and therefore cannot determine whether any particular transaction is suitable for the Subscriber.</p>

        <h3>5. No Fiduciary or Agency Relationship</h3>
        <p className="mb-2">5.1. The Subscriber acknowledges that joining the Group does not create a fiduciary, trustee, agency, partnership, employment, joint-venture or similar relationship between the Parties.</p>
        <p className="mb-2">5.2. Unless separately agreed in writing and legally authorized, the Group Operator does not have authority to operate the Subscriber's exchange account, wallet or other financial account.</p>
        <p className="mb-3">5.3. The Subscriber retains complete control over his/her assets and trading accounts.</p>

        <h3>6. Exchange, Wallet and Third-Party Risks</h3>
        <p className="mb-2">The Subscriber acknowledges that the Group Operator is not responsible for losses arising from:</p>
        <ul className="mb-3">
          <li>Exchange outages or suspension of withdrawals;</li>
          <li>Exchange bankruptcy or insolvency;</li>
          <li>Hacking, phishing or cyberattacks;</li>
          <li>Loss or theft of private keys or passwords;</li>
          <li>Incorrect wallet addresses or blockchain transactions;</li>
          <li>Network congestion or blockchain failure;</li>
          <li>Liquidation of leveraged positions;</li>
          <li>Slippage, spread or liquidity problems;</li>
          <li>Unauthorized access to the Subscriber's account;</li>
          <li>Actions, omissions, negligence or failures of third-party exchanges, brokers, wallet providers or other service providers; or</li>
          <li>Regulatory, governmental or legal changes affecting virtual assets.</li>
        </ul>

        <h3>7. Express Waiver and Release</h3>
        <p className="mb-2">
          To the fullest extent permitted by applicable law, the Subscriber voluntarily releases and discharges the Group Operator, together with his/her employees, representatives, agents and authorized personnel, from claims arising solely from the Subscriber's independent trading or investment decisions based upon information, analysis, opinions or material made available through the Group.
        </p>
        <p className="mb-3">
          This release does not purport to exclude liability which cannot lawfully be excluded, including liability arising from fraud, fraudulent misrepresentation, wilful misconduct or any other liability which applicable law does not permit the Parties to exclude or limit.
        </p>

        <h3>8. Indemnity</h3>
        <p className="mb-2">8.1. To the fullest extent permitted by applicable law, the Subscriber agrees to indemnify and hold harmless the Group Operator from and against claims, losses, liabilities, damages, costs and reasonable expenses arising from or relating to:</p>
        <ul className="mb-2">
          <li>The Subscriber's trading or investment decisions;</li>
          <li>The Subscriber's use or misuse of information provided through the Group;</li>
          <li>The Subscriber's breach of this Agreement;</li>
          <li>Transactions undertaken by the Subscriber through any exchange, broker, wallet or other third-party platform;</li>
          <li>The Subscriber's unauthorized disclosure, reproduction, redistribution or commercial use of Group content; or</li>
          <li>Any representation or undertaking made by the Subscriber to a third party concerning the Group Operator or the Group.</li>
        </ul>
        <p className="mb-3">8.2. The indemnity contained in this clause shall not extend to liability finally determined by a competent court to have resulted from the Group Operator's fraud, wilful misconduct or other liability which cannot lawfully be indemnified or excluded.</p>

        <h3>9. No Liability for Market Losses</h3>
        <p className="mb-2">
          To the fullest extent permitted by applicable law, the Group Operator shall not be liable for any loss of capital, trading loss, loss of anticipated profit, loss of opportunity, liquidation loss, consequential loss or other financial loss suffered by the Subscriber merely because a cryptocurrency or trading idea discussed in the Group subsequently declined in value.
        </p>
        <p className="mb-3">The Subscriber acknowledges that loss of money is an inherent and foreseeable risk of cryptocurrency trading.</p>

        <h3>10. Subscription Fee</h3>
        <p className="mb-2">10.1. The Subscriber understands that the subscription fee is paid for access to the Group and its content/community during the applicable subscription period.</p>
        <p className="mb-2">10.2. Payment of a subscription fee does not constitute payment for a guaranteed financial return or guaranteed trading performance.</p>
        <p className="mb-3">10.3. Unless otherwise expressly stated by the Group Operator in writing, subscription fees are non-refundable once access to the Group has been provided, subject always to any mandatory rights available to the Subscriber under applicable law.</p>

        <h3>11. Confidentiality and Non-Redistribution</h3>
        <p className="mb-2">11.1. All paid content, messages, calls, analyses, research, charts, recordings, strategies, documents and other materials supplied within the Group are confidential and intended solely for the Subscriber.</p>
        <p className="mb-2">11.2. The Subscriber shall not, without prior written permission:</p>
        <ul className="mb-2">
          <li>Copy or reproduce paid content;</li>
          <li>Forward or publish Group messages;</li>
          <li>Share access with another person;</li>
          <li>Sell or commercially distribute Group material;</li>
          <li>Operate a competing channel using substantially similar proprietary Group material; or</li>
          <li>Publicly distribute screenshots or recordings of paid Group content.</li>
        </ul>
        <p className="mb-3">11.3. The Group Operator may suspend or terminate the Subscriber's access where there is a reasonable basis to believe that these provisions have been violated.</p>

        <h3>12. Security of Account</h3>
        <p className="mb-2">The Subscriber is solely responsible for maintaining the confidentiality of his/her passwords, authentication credentials, wallet credentials and account access information.</p>
        <p className="mb-3">The Group Operator shall never be responsible for losses caused by the Subscriber voluntarily disclosing such information to another person.</p>

        <h3>13. Regulatory and Legal Risks</h3>
        <p className="mb-2">The Subscriber acknowledges that laws and regulations concerning cryptocurrency and virtual assets may change from time to time and may differ according to jurisdiction.</p>
        <p className="mb-2">The Subscriber is solely responsible for determining whether cryptocurrency trading and the Subscriber's intended transactions are lawful in the jurisdiction applicable to the Subscriber.</p>
        <p className="mb-3">Nothing in this Agreement shall be interpreted as authorizing an activity that requires a governmental licence, registration, approval or authorization where such authorization has not been obtained.</p>

        <h3>14. Age and Capacity</h3>
        <p className="mb-2">The Subscriber represents and warrants that:</p>
        <ul className="mb-3">
          <li>He/she has attained the legal age and capacity required to enter into this Agreement;</li>
          <li>He/she is legally competent to enter into a binding contract; and</li>
          <li>The funds used for subscription and subsequent trading are lawfully owned or controlled by the Subscriber.</li>
        </ul>

        <h3>15. Voluntary Assumption of Risk</h3>
        <p className="mb-2">The Subscriber confirms that he/she is voluntarily joining the Group after having been informed that cryptocurrency trading involves substantial risk, including the possibility of losing some or all of the capital committed to a transaction.</p>
        <p className="mb-3">The Subscriber accepts responsibility for the consequences of his/her own trading and investment decisions.</p>

        <h3>16. Acknowledgment of Understanding</h3>
        <p className="mb-2">By joining the Group, the Subscriber confirms that:</p>
        <ul className="mb-3">
          <li>I understand that cryptocurrency trading involves substantial risk.</li>
          <li>I understand that I can lose part or all of my invested capital.</li>
          <li>I understand that the Group Operator does not guarantee profits.</li>
          <li>I understand that previous results do not guarantee future results.</li>
          <li>I make my own trading and investment decisions.</li>
          <li>I accept responsibility for losses resulting from my own decisions, subject to applicable law.</li>
          <li>I have read and accepted the waiver, release and indemnity provisions of this Agreement.</li>
          <li>I understand that payment of the subscription fee does not purchase a guaranteed return.</li>
        </ul>

        <h3>17. Entire Agreement</h3>
        <p className="mb-3">This Agreement constitutes the understanding between the Parties concerning the matters addressed herein and supersedes any inconsistent oral representation concerning liability for the Subscriber's trading losses. No amendment shall be binding unless communicated or accepted in writing by the Group Operator.</p>

        <h3>18. Severability</h3>
        <p className="mb-3">If any provision of this Agreement is determined by a competent court to be unlawful, invalid or unenforceable, that provision shall be modified or severed to the minimum extent necessary, and the remaining provisions shall continue to the fullest extent permitted by law.</p>

        <h3>19. Governing Law and Jurisdiction</h3>
        <p className="mb-2">This Agreement shall be governed by the laws of Pakistan, subject to any mandatory applicable law.</p>
        <p className="mb-3">Any dispute arising out of or relating to this Agreement shall be submitted to the jurisdiction of the competent courts having lawful jurisdiction over the matter.</p>

        <h3>20. Electronic Acceptance</h3>
        <p className="mb-2">The Subscriber's electronic acceptance, including clicking "I Agree," "Join," "Subscribe," "Accept Terms," or a substantially similar confirmation, shall constitute acknowledgment and acceptance of this Agreement to the extent permitted by applicable law.</p>
        <p className="mb-3">The Subscriber agrees that electronic records of such acceptance may be retained and produced as evidence of acceptance.</p>

        <div className="legalNotice mb-3">
          <p><b>Subscriber Declaration</b></p>
          <p>I, the undersigned Subscriber, confirm that I have carefully read and understood this Agreement. I understand the risks associated with cryptocurrency trading and voluntarily assume responsibility for my own trading and investment decisions.</p>
          <p>I acknowledge that no profit, return or successful trading outcome has been guaranteed to me, and I agree to the waiver, release and indemnity provisions contained herein to the fullest extent permitted by applicable law.</p>
        </div>

        <h2>Educational &amp; Informational Use Only</h2>
        <p>
          All content, crypto signals, trading strategies, commentary, or
          communications shared via{" "}
          <a href="https://waqarzaka.net/">www.waqarzaka.net</a> or its
          affiliated platforms (including but not limited to Signal, Telegram,
          WhatsApp, or email) are intended solely for educational and
          informational purposes.
        </p>
        <p className="mb-3">
          They are not a substitute for professional financial, legal, or tax
          advice.
        </p>

        <h2>
          No Financial Advice – Opinions Only (with Global Jurisdictional
          Disclaimer)
        </h2>
        <p className="mb-3">
          Waqar Zaka and his team may share personal opinions, trade setups, and
          buy/sell signals as part of their educational services. However, all
          such content is provided strictly for informational purposes and does
          not constitute financial advice, portfolio management, or a
          recommendation to trade any specific asset.
        </p>
        <p className="mb-3">You acknowledge and agree that:</p>
        <p className="mb-3">
          Waqar Zaka and his team are not licensed financial advisors, brokers,
          or investment professionals in any jurisdiction, including but not
          limited to:
        </p>
        <ul>
          <li>The United States (SEC, CFTC, FINRA),</li>
          <li>The United Kingdom (FCA),</li>
          <li>The European Union (ESMA),</li>
          <li>The United Arab Emirates (SCA, DFSA),</li>
          <li>Singapore (MAS) and all other global regulatory bodies.</li>
        </ul>
        <p className="mb-3">
          All information shared is general in nature, not customized to your
          financial circumstances, and does not establish any fiduciary duty or
          client-advisor relationship.
        </p>
        <p className="mb-3">
          Waqar Zaka and his team do not solicit, induce, or guarantee any
          outcome or return. Past performance is not indicative of future
          results.
        </p>
        <p className="mb-3">
          By using our content, you waive all claims of misrepresentation,
          reliance, market manipulation, or legal liability under any financial
          services or securities regulation worldwide.
        </p>
        <h2>No Guarantee of Results</h2>
        <p>
          We make no warranties, express or implied, regarding the accuracy,
          reliability, timeliness, or future performance of any content.
        </p>
        <p className="mb-3">
          You acknowledge that all forms of trading and investing carry inherent
          risks, including the loss of your entire capital.
        </p>
        <h2>Jurisdictional Restrictions</h2>
        <p>
          Our services are not intended for use in jurisdictions where the
          transmission or use of such content would be unlawful or restricted.
        </p>
        <p>
          You are solely responsible for ensuring your participation complies
          with local laws, financial regulations, and restrictions.
        </p>

        <h2>Limitation of Liability</h2>
        <p className="mb-3">
          Waqar Zaka and all related parties (including team members,
          affiliates, contractors, and contributors) shall not be held liable
          for any form of damages — direct, indirect, incidental, punitive, or
          consequential — including but not limited to:
        </p>

        <ul>
          <li>Loss of capital or profits,</li>
          <li>Missed trades or opportunities,</li>
          <li>Trading errors based on content reliance,</li>
          <li>Or emotional, legal, or financial distress.</li>
        </ul>

        <p className="mb-3">
          This limitation applies regardless of the legal theory, even if
          advised of the possibility of such damages.
        </p>

        <h2>Product Access & No Refund Policy</h2>
        <p className="mb-3">
          Upon successful payment, users are granted access to the WaqarZaka.net
          dashboard, which constitutes delivery of the digital product and its
          associated services. By completing the purchase and receiving
          dashboard access, the user acknowledges that the product has been
          fully delivered. Accordingly, all sales are final, and no refunds will
          be issued once access to the dashboard has been provided. Any refund
          requests submitted after gaining access will be declined. By
          proceeding with the purchase, you agree to this policy and confirm
          your understanding that access to the platform represents fulfillment
          of the service.
        </p>

        <h2>Personal Responsibility & Risk Acceptance</h2>
        <p className="mb-3">You are solely responsible for:</p>
        <ul>
          <li>Evaluating all shared information,</li>
          <li>Conducting your own due diligence,</li>
          <li>Consulting with a qualified financial professional,</li>
          <li>Making independent investment or trading decisions.</li>
        </ul>
        <p className="mb-3">
          By participating, you voluntarily assume all risks, and agree to
          indemnify and hold harmless Waqar Zaka and associated parties from any
          legal action, claim, or loss arising out of your use of our services.
        </p>
        <h2>No Refund – No Chargeback Policy</h2>
        <p>
          Due to the nature of digital and educational content, all payments
          made for services, access, or subscriptions are non-refundable.
        </p>
        <p className="mb-3">
          By proceeding with any payment, you waive any right to refunds,
          disputes, or chargebacks, regardless of perceived results or
          experience.
        </p>
        <h2>Binding Agreement</h2>
        <p className="mb-3">
          By accessing <a href="https://waqarzaka.net/">www.waqarzaka.net</a> or
          any related groups, you confirm that you:
        </p>
        <ul>
          <li>Have read, understood, and accepted this disclaimer in full,</li>
          <li>Enter into a binding agreement,</li>
          <li>
            And irrevocably waive any future legal claims based on reliance,
            misunderstanding, or dissatisfaction.
          </li>
        </ul>
        <p className="mb-3">
          This disclaimer shall be governed by applicable international and
          local laws, and any disputes shall be resolved under the jurisdiction
          Waqar Zaka or his company designates.
        </p>
        <p>
          <b>Final Note</b>
        </p>
        <p>You trade at your own risk.</p>
        <p>
          Waqar Zaka and his team are not responsible for your profits, losses,
          decisions, or emotions.
        </p>
        <p>Your risk. Your decision. Your responsibility.</p>

        <h2>GENERAL DISCLAIMER</h2>
        <p className="mb-3">
          This Website is for educational and informational purposes only. We do
          not provide financial, investment, legal, or tax advice. Any content,
          materials, or courses available on this platform should not be
          construed as professional financial guidance. Always consult a
          licensed financial advisor, attorney, or tax professional before
          making any trading or investment decisions.
        </p>
        <h2>No Financial Or Investment Advice</h2>
        <p className="mb-3">
          We are not financial advisors, brokers, or investment professionals.
          No content on this Website constitutes financial, investment, or legal
          advice. Any financial or trading decisions you make based on our
          content are strictly at your own risk. Past performance is not
          indicative of future results.
        </p>
        <h2>Risk Disclosure</h2>
        <p className="mb-3">
          Trading and investing involve substantial risk, including the
          potential loss of your entire investment. The cryptocurrency and forex
          markets are highly volatile and not suitable for all investors. Only
          invest funds that you can afford to lose.
        </p>
        <h2>Personal Responsibility</h2>
        <p className="mb-3">
          By using this Website, you acknowledge that you are solely responsible
          for your financial decisions. We do not guarantee any specific
          financial outcomes or success, and we are not liable for any losses or
          damages arising from the use of our materials. Testimonials or success
          stories are exceptional and not typical. <br />
        </p>
        <p className="mb-3">
          All content is provided “as is” and “as available,” with no warranties
          of accuracy, completeness, or reliability. Although we strive to keep
          information current, we make no guarantees that all content is free
          from errors or outdated material.
        </p>
        <h2>Third-Party Links And Affiliates</h2>
        <p className="mb-3">
          This Website may include links to third-party websites, sponsored
          content, or affiliate promotions. We do not own or control third-party
          services and are not responsible for their accuracy, reliability, or
          legitimacy. Interactions with these services are at your own risk. We
          may receive commissions from affiliate links, but our content is not
          influenced by these affiliations.
        </p>
        <h2>Privacy Policy</h2>
        <p className="mb-3">
          By using this Website, you acknowledge that you have read and agreed
          to our Privacy Policy, which explains:
          <ul className="mt-3">
            <li>
              What personal data we collect (e.g., email, payment details,
              analytics)
            </li>
            <li>How we use and store that data</li>
            <li>Our third-party sharing practices</li>
            <li>Your rights, including how to request data deletion</li>
          </ul>
          Refer to the full [Privacy Policy] page for more information.
        </p>
        <h2>Billing, Payments, & Subscriptions</h2>
        <h5>1. Support Ticket Requirement for Payment Issues</h5>

        <p>
          If you experience any issues accessing the platform{" "}
          <b>after a successful payment</b>, you must first create a support
          ticket via our Help Desk. Our support team will aim to resolve your
          issue <b>within 12 hours</b>.
        </p>
        <p>
          If your issue is not resolved after 12 hours, you may then proceed to
          open a <b>payment dispute or refund request</b> via Stripe.
        </p>
        <p className="mb-3">
          <b>⚠️ Important: </b> Initiating a dispute without first creating a
          support ticket is a violation of our terms and may result in denied
          claims.
        </p>
        <h5>2. Auto-Renewal Subscription Policy</h5>

        <p className="mb-3">
          By subscribing to our platform, you acknowledge and agree that your{" "}
          <b>subscription renews automatically every month</b>.
          <ul className="mt-3">
            <li>The first payment will require your authorization.</li>
            <li>
              Subsequent payments will be automatically deducted from your
              credit card without requiring re-authorization. <br /> You may
              cancel the subscription at any time before the next billing cycle
              through your account settings.
            </li>
            <li>
              <div style={{ color: "red" }}>
                <b>Note: No Refund on Recurring Payments:</b> All recurring
                subscription charges are strictly non-refundable. If you fail to
                cancel before the next billing cycle, the renewal charge will be
                processed automatically and no refund, reversal, or
                reimbursement will be issued.
              </div>
            </li>
          </ul>
        </p>
        <h2>Refund Policy</h2>
        <p className="mb-3">
          All sales of digital products, including courses and subscriptions,
          are <b>final and non-refundable</b>, except in cases of{" "}
          <b>accidental duplicate purchases</b>.
        </p>
        <h2>Content Usage & User Conduct</h2>
        <ul>
          <li>
            Users may not copy, distribute, or reproduce any content without{" "}
            <b>written permission</b>.
          </li>
          <li>Unauthorized use of our content may result in legal action.</li>
          <li>
            Users must not engage in fraud, harassment, illegal activities, or
            violation of these terms.
          </li>
          <li>
            We reserve the right to <b>suspend or terminate any user account</b>{" "}
            that violates these terms.
          </li>
        </ul>
        <h2>Limitation Of Liability</h2>
        <p className="mb-3">
          To the fullest extent permitted by law, we shall not be liable for any
          direct, indirect, incidental, consequential, or special damages
          arising from:
        </p>
        <ul>
          <li>Use of or inability to use our Website</li>
          <li>Errors or inaccuracies in content</li>
          <li>Third-party services or external links</li>
          <li>Loss of profits, revenue, or financial data</li>
        </ul>
        <h2>Modifications</h2>
        <p className="mb-3">
          We reserve the right to update or modify this legal disclaimer and
          terms of use at any time without prior notice. It is your
          responsibility to check this page regularly for updates.
        </p>

        <h2>Email Accuracy, Subscription Cancellation & Refund Policy</h2>
        <h5>1. Accuracy of Information</h5>
        <p className="mb-3">
          By registering for our services, you are responsible for providing
          accurate and complete information, including a valid and correctly
          spelled email address. We will not be responsible for any issues
          arising from an incorrect, misspelled, or invalid email address
          entered by you during registration.
        </p>
        <h5>2. Email Correction Period</h5>
        <p>
          If you accidentally provide an incorrect or misspelled email address
          during registration, you may contact our support team within 24 hours
          of registration to request a correction. Our support team may assist
          in correcting the email address, subject to verification and
          applicable procedures.
        </p>
        <p className="mb-3">
          After the 24-hour period has expired, we will not be responsible for
          any issues resulting from an incorrect email address, and no refund or
          compensation will be provided on this basis.
        </p>
        <h5>3. Subscription Cancellation</h5>
        <p className="mb-3">
          It is your sole responsibility to cancel your subscription before the
          next billing cycle if you no longer wish to continue using our
          services. Failure to cancel your subscription in a timely manner will
          not constitute grounds for a refund.
        </p>
        <h5>4. Customer Support</h5>
        <p className="mb-3">
          If you experience any issues with your account or subscription, you
          are responsible for contacting our support team promptly and providing
          the necessary information to resolve the issue. Failure to contact
          support in a timely manner will not entitle you to a refund.
        </p>
        <h5>5. Refunds</h5>
        <p className="mb-3">
          No refunds will be provided for issues resulting from incorrect
          information provided by the customer, failure to cancel a
          subscription, or failure to contact our support team within the
          applicable time period.
        </p>
      </div>
    </div>
  );
};
